import { render, staticRenderFns } from "./blogsFront.vue?vue&type=template&id=5037deab&scoped=true"
import script from "./blogsFront.vue?vue&type=script&lang=js"
export * from "./blogsFront.vue?vue&type=script&lang=js"
import style0 from "./blogsFront.vue?vue&type=style&index=0&id=5037deab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5037deab",
  null
  
)

export default component.exports